import React, { createContext, useContext, useState, useCallback } from 'react';

const MarketContext = createContext();

export const MARKETS = [
  { code: 'bg', lang: 'bg', label: 'България',  flag: '🇧🇬', path: '/',        native: 'България' },
  { code: 'gr', lang: 'el', label: 'Ελλάδα',    flag: '🇬🇷', path: '/Greece',  native: 'Ελλάδα' },
  { code: 'tr', lang: 'tr', label: 'Türkiye',   flag: '🇹🇷', path: '/Turkiye', native: 'Türkiye' },
  { code: 'en', lang: 'en', label: 'Global',     flag: '🌍', path: '/Global',  native: 'Global' },
];

// Detect market from a URL pathname (URL is the single source of truth).
// Case-insensitive so /greece and /Greece both work; legacy short paths
// (/gr, /tr, /en) still resolve so old links keep functioning while
// App.js redirects them to the new paths.
function marketFromPath(pathname) {
  const p = pathname.toLowerCase();
  if (p === '/greece' || p.startsWith('/greece/') || p === '/gr' || p.startsWith('/gr/')) return 'gr';
  if (p === '/turkiye' || p.startsWith('/turkiye/') || p === '/tr' || p.startsWith('/tr/')) return 'tr';
  if (p === '/global' || p.startsWith('/global/') || p === '/en' || p.startsWith('/en/')) return 'en';
  return 'bg';
}

export function MarketProvider({ children }) {
  // Initialize from current URL path — IP redirect is handled in App.js IpRedirect
  const [market, setMarketState] = useState(() => marketFromPath(window.location.pathname));

  const setMarket = useCallback((code) => {
    if (MARKETS.find(m => m.code === code)) {
      setMarketState(code);
    }
  }, []);

  // Build a market-aware link (prefixes path with /Greece, /Turkiye, /Global; nothing for bg)
  const marketLink = useCallback((path) => {
    const m = MARKETS.find(x => x.code === market);
    const prefix = (!m || m.code === 'bg') ? '' : m.path;
    if (path === '/') return prefix || '/';
    return `${prefix}${path}`;
  }, [market]);

  const currentMarket = MARKETS.find(m => m.code === market) || MARKETS[0];
  const marketPathPrefix = currentMarket.code === 'bg' ? '' : currentMarket.path;

  const value = {
    market,
    setMarket,
    markets: MARKETS,
    currentMarket,
    marketLink,
    marketPathPrefix,
  };

  return (
    <MarketContext.Provider value={value}>
      {children}
    </MarketContext.Provider>
  );
}

export function useMarket() {
  const ctx = useContext(MarketContext);
  if (!ctx) throw new Error('useMarket must be used within MarketProvider');
  return ctx;
}
